/**
 * Sprint H Phase 3 — admin-side ApiClient subclass.
 *
 * Extends shared `ApiClient` so admin-specific typed methods can be added
 * here without polluting the shared base (storefront / floristy don't need
 * them). Today this is a thin pass-through; future admin domain APIs that
 * need typed helpers beyond `apiClient.requestRaw` should land here.
 *
 * Singleton lives in `services/api.ts` — every admin code path imports
 * `apiClient` from there. After Sprint H Phase 3 that singleton is an
 * AdminApiClient instance, so `apiClient.foo()` resolves admin methods
 * defined here AND inherited shared methods (get/post/put/delete/requestRaw).
 */

import { ApiClient } from '@tenant/shared'

export class AdminApiClient extends ApiClient {
  // Scaffolding: future admin-only typed methods land here. As of Sprint H
  // Phase 3 every admin call-site resolves through inherited members of
  // ApiClient — adding ad-hoc admin methods now would violate YAGNI.
}
